var swiftypeKey = 'QRRfMeh1QvEuKbJ_9cSF'; //PYxrpUNc8zBj3chr1cr9

function makeSquare(selector) {
  $(selector).height('').each(function () {
    $(this).height($(this).width()).addClass('squared');
  });
}

var lastSearch = ''

//Update Categories, Brands and Distributors filters every time that user search a new term
function updateFilters(query) {

  if (query != lastSearch) {
    lastSearch = query;

    //async call to retrieve all categories, brands and distributors from products
    $.post(
      "https://search-api.swiftype.com/api/v1/public/engines/search.json",
      {
        "engine_key": swiftypeKey,
        "q": query,
        "per_page": 100,
        "fetch_fields": {
          "page": [
            "minor_category",
            "brand",
            "suppliers"
          ]
        }
      },
      function (result) {

        const records = result.records.page;
        let categories = []
        let brands = []
        let distributors = []
        //iterate each product to take the different categories, brands and distributors
        $.each(records, function (i, record) {
          if ($.inArray(record.brand, brands) == -1) brands.push(record.brand);
          if ($.inArray(record.minor_category, categories) == -1) categories.push(record.minor_category);
          if (record.suppliers) {
            $.each(record.suppliers, function (i, distributor) {
              if ($.inArray(distributor, distributors) == -1) distributors.push(distributor);
            })
          }
        })

        categories.sort()
        brands.sort()
        distributors.sort()

        //update category checkboxes
        if (categories.length > 0) {
          let categoryFilters = ''
          $.each(categories, function (i, category) {
            if(category){
              categoryFilters += `<li><label class="custom_cb"><input type="checkbox" name="filter_category" value="${category}"> <span>${category}</span></label></li>`;
            }
          });
          $('#category_filter_list').html(categoryFilters);
          $('#category-filter-section').show();
        } else {
          $('#category-filter-section').hide();
        }

        //update brand checkboxes
        if (brands.length > 0) {
          let brandFilters = ''
          $.each(brands, function (i, brand) {
            brandFilters += `<li><label class="custom_cb"><input type="checkbox" name="filter_brand" value="${brand}"> <span>${brand}</span></label></li>`
          });
          $('#brand_filter_list').html(brandFilters);
          $('#brand-filter-section').show();
        } else {
          $('#brand-filter-section').hide();
        }

        //update distributor checkboxes
        if (distributors.length > 0) {
          let distributorFilters = ''
          $.each(distributors, function (i, distributor) {
            distributorFilters += `<li><label class="custom_cb"><input type="checkbox" name="filter_distributor" value="${distributor}"> <span>${distributor}</span></label></li>`
          });
          $('#distributor_filter_list').html(distributorFilters)
          $('#distributor-filter-section').show();
        } else {
          $('#distributor-filter-section').hide();
        }

        //update distributor location checkboxes
        let customerLocation = "";
        if ($('input[name=customer_state]').length > 0 && $('input[name=customer_state]').first().val() != "") {
          customerLocation = $('input[name=customer_selected_state]').first().val();
        }
        let distributorLocationFilters = '';

        for (const key in states) {
          distributorLocationFilters += `<li><label class="custom_cb"><input type="radio" name="filter_distributor_location" value="${key}" ${customerLocation === states[key] && 'checked'} id="locationSelected"> <span>${states[key]}</span></label></li>`;
        };
        $('#distributor_location_filter_list').html(distributorLocationFilters);
        $("#distributor_location_filter_list").scrollTop($('#locationSelected').position().top);
        
        $("input[name=filter_category], input[name=filter_brand], input[name=filter_distributor], input[name=filter_distributor_location]").on('change', filterChange)
        // If it's a radio button, we need to allow them to unselect it completely. 
        $("input[type='radio'][name^='filter_']").on('click', function() {
          const currentElement = $(this);
          if (currentElement.attr("checked") === true || currentElement.attr("checked") === "checked") {
            currentElement.attr("checked", false);
            currentElement.prop("checked", false);
            currentElement.on('change');
            if (currentElement.attr("name") === "filter_distributor_location") {              
              updateCartAttribute();
            }
          } else {
            currentElement.attr("checked", true);
            currentElement.prop("checked", true);
          }
        })
      }
    );
  }
}

function goSearch() {
  if ($('#st-search-input').val() != "") {

    $('.close_icon').on('click');
    // Track 'Products Searched' event
    trackSearch($('#st-search-input').val());
    const encodedSearchInput = encodeURIComponent($('#st-search-input').val())
    window.location.href = '/search#stq=' + encodedSearchInput + '&stp=1';
  }
}

function filterChange() {
  let filtersApplied = '';
  let selectedReviewScores = [];

  $("input[name^='filter_']:checked").each(function () {
    let label = $(this).val();
    if (this.name == 'filter_distributor_location') {
      let state = $(this).next().text();
      label = `Delivery Location: <span id="selected_distributor_location">${state}</span>`;
      updateCartAttribute(state);
    } else if (this.name.includes("filter_average_review_")) {
      let scoreFilter = $(this).val().split(" ");
      if (scoreFilter.length > 0) {
        const score = scoreFilter[0];
        selectedReviewScores.push(score);
      }
    }
    filtersApplied += `<li>${label}</li>`;
  })

  if (selectedReviewScores.length > 0) {
    filtersApplied += `<input type="hidden" id="selected_review_score" value="${selectedReviewScores.join(",")}" />`;
  }

  $(".applied_items").html(filtersApplied);

  $(".clear_filters").toggleClass('d-none', filtersApplied == '');

  location.hash = 'stq=' + $('#st-search-input').val() + '&stp=1';
  Swiftype.reloadResults();
}

function clearFilters() {
  $("input[name^='filter_']:checked").each(function () {
    $(this).prop('checked', '')
  })
  updateCartAttribute();

  filterChange();
}

function readFilters() {
  let filters = { page: {} };

  //filter by Category
  if ($('input[name=filter_category]:checked').length > 0) {
    filters.page.minor_category = [];
    $('input[name=filter_category]:checked').each(function () {
      filters.page.minor_category.push($(this).val());
    });
  }

  //filter by Brand
  if ($('input[name=filter_brand]:checked').length > 0) {
    filters.page.brand = [];
    $('input[name=filter_brand]:checked').each(function () {
      filters.page.brand.push($(this).val());
    });
  }

  //filter by Distributors
  if ($('input[name=filter_distributor]:checked').length > 0) {
    filters.page.suppliers = [];
    $('input[name=filter_distributor]:checked').each(function () {
      filters.page.suppliers.push($(this).val());
    });
  }

  //filter by Distributor location
  if ($('input[name=filter_distributor_location]:checked').length > 0) {
    filters.page.distributor_locations = [];
    $('input[name=filter_distributor_location]:checked').each(function () {
      filters.page.distributor_locations.push($(this).val());
    });
  }

  //filter by Reviews with images
  if ($('input[name=filter_has_review_image]:checked').length > 0) {
    filters.page.has_review_image = 1;
  }

  //filter by Reviews with images
  if ($('input[name=filter_has_q_and_a]:checked').length > 0) {
    filters.page.has_q_and_a = 1;
  }

  //filter by Rewards eligible
  if ($('input[name=filter_rewards]:checked').length > 0) {
    filters.page.rewards = 1;
  }

  return filters
}

function trackSearch(searchText) {
  analytics.track('Products Searched', {
    category: 'Search',
    label: searchText,
    search_text: searchText
  });
}

function trackFeatureProductImpression(searchText, productId, productTitle) {
  analytics.track('Featured Product Impression', {
    category: 'Search',
    label: productTitle,
    search_text: searchText,
    product_id: productId,
    product_title: productTitle,
  });
}

function onExternalFeaturedProductClick(searchText, productId, productTitle, productUrl) {
  productTitle = decodeURIComponent(productTitle);
  productUrl = decodeURIComponent(productUrl);
  trackFeatureProductClick(searchText, productId, productTitle);
  window.open(productUrl);
}

function trackFeatureProductClick(searchText, productId, productTitle) {
  analytics.track('Featured Product Clicked', {
    category: 'Search',
    label: productTitle,
    search_text: searchText,
    product_id: productId,
    product_title: productTitle,
  });
}

async function fetchYotpoReviews(yotpoTokenUrl, yotpoAppKey, startReviewTtl) {

  let yotpoReviews = getLocalStorageItem("yotpo_reviews");

  if (!yotpoReviews || Object.keys(yotpoReviews).length < 100) {

    const response = await fetch(yotpoTokenUrl)
    const token = await response.text();

    options = {
      method: 'GET',
      headers: {Accept: 'application/json', 'Content-Type': 'application/json'}
    };

    let allReviews = [];
    let page = 1;
    let hasMorePages = true;

    while (hasMorePages) {
      const reviewsResponse = await fetch(`https://api.yotpo.com/v1/apps/${yotpoAppKey}/reviews?utoken=${token}&count=100&page=${page}`, options);
      const reviewsResponseJson = await reviewsResponse.json();
      
      if (reviewsResponseJson.reviews && reviewsResponseJson.reviews.length > 0) {
        allReviews = [...allReviews, ...reviewsResponseJson.reviews];
        page++;
      } else {
        hasMorePages = false;
      }
    }

    allReviews = groupYotpoReviews(allReviews, "sku");

    setLocalStorageItem("yotpo_reviews", allReviews, startReviewTtl);

    yotpoReviews = allReviews;
  }

  return yotpoReviews;
}

function groupYotpoReviews (array, key) {
  return array.reduce(function(rv, x) {
    const valueExists = rv[x[key]];
    let average = {};
    if (valueExists) { // If there are already scored saved, we re-calculate the average
      // newAverageScore is the current average times the current count + the new score. All devided by the new sum, (current count + 1) 
      // e.g: { average : { score: 4, count: 2 }} and new score is 5:
      // ((4*2) + 5) / 3 which could be translated to (4 + 4 + 5) / 3 
      const newAverageScore = ((valueExists.score * valueExists.count) + x.score) / (valueExists.count + 1);
      average = {
        score: parseFloat(newAverageScore.toFixed(2)),
        count: valueExists.count + 1
      }

    } else { // If it's the first score to be saved
      average = {
        score: x.score,
        count: 1
      }
    }

    rv[x[key]] = average;
    return rv;
  }, {});
};

$(function () {

  // This function returns the HTML for the autocomplete search result item (featured and regular products)
  var customResultRenderFunction = function (ctx, data) {
    var results = [];

    $.each(data, function (docType, thisresult) {
      results = results.concat(thisresult);
    });

    var resultsDiv = $('<div class="all_results search-ajax__content row equal"></div>');

    $.each(results, function (idx, item) {

      const isProductFeatured = item._score === 1;
      var itemHtml = '';
      if(isProductFeatured) {
        itemHtml += `<script type="text/javascript">trackFeatureProductImpression("${$('#st-search-input').val()}", "${item.shopify_id}", "${item.title}");</script>`;
        item.URL = item.search_url ? item.search_url : item.URL;
      }
      itemHtml += '<div class="result col-12 p-10 product-search-2 d-flex flex-row">';
      itemHtml += '<div class="product-search-2__image d-flex align-items-start mr-10"><img src="' + item.image + '"></div>';
      itemHtml += '<div class="product-search-2__content d-flex flex-column ml-3"><div class="product-search-2__title mb-5">';
      if (typeof item.brand != "undefined") {
        itemHtml += '<h4 class="h6 m-0">' + item.brand + '</h4>';
      }
      itemHtml += '<h3 class="h6 m-0">' + item.title + '</h3>';
      itemHtml += '</div></div></div>';
      ctx.registerResult($(itemHtml).appendTo(resultsDiv), item);
    });
    if (resultsDiv.length > 0) {
      $('<div class="col-12 search-title mt-10 d-lg-none">Results</div>').prependTo(resultsDiv);
      $('<div class="col-12 search-ajax__view-all"><a href="javascript:;" onclick="goSearch();" class="p-10 d-flex justify-content-center">View all products</a></div>').appendTo(resultsDiv);
      resultsDiv.appendTo(ctx.list);
      setTimeout(function () {
        makeSquare('.product-search-2__image');
      }, 500);
    }
  };

  // This function returns the HTML for the regular search result item (featured and regular products)
  var customSearchResultRenderFunction = function (type, item) {

    const isProductFeatured = item._score === 1;
    const rebatesAndRewards = item.rebates == 'Rebates' || item.points == 'Points' ?
      `<div class="product-eligibility">
        <div class="reward-point-eligible"><strong>Reward Points Eligible</strong></div>
        <div class="cash-rebate-eligible"><strong>Cash Rebate Eligible</strong></div>
      </div>
      `
      : ``

    var distributors = {};
    let invoicesInfo = ''
    var distributors_state = item.suppliers_state
    if (distributors_state) {
      distributors_state.map(function (distributors_state_tag) {
        var splits = distributors_state_tag.split('_');
        if (typeof distributors[splits[1]] == 'undefined') {
          distributors[splits[1]] = [];
        }
        distributors[splits[1]].push(splits[0]);
      });

      Object.keys(distributors).map(function (state) {
        invoicesInfo += `
        <strong>${states[state]}</strong>:<br>
        <div class="recent-invoice-list">`

        distributors[state].map(function (distributor) {
          invoicesInfo += `<div><a href="#">${distributor}</a></div>`;
        });
        invoicesInfo += '</div>';
      });
    }

    const hasReviews = item.average_review != undefined;


    // If has reviews -> call async Yotpo API to retrieve last review text
    if (hasReviews) {
      var data = null;

      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
          const response = JSON.parse(this.response)

          if (response.response && response.response.reviews && response.response.reviews.length > 0) {

            let reviews = response.response.reviews;

            reviews.sort(function (a, b) {
              return new Date(b.created_at) - new Date(a.created_at);
            });

            $(`#product-description-${item.id}`).html(`"${reviews[0].title}"</br>"${reviews[0].content}"`)
          }
        }
      });

      xhr.open("GET", `https://api.yotpo.com/v1/widget/8tqEhmg1uCL747UIka6ea7SyOe2XU0j4RyxKoeLL/products/${item.shopify_id}/reviews.json`);
      xhr.setRequestHeader("content-type", "application/json");

      xhr.send(data);
    }

    const averageReview = parseFloat(item.average_review)

    const reviewStars = hasReviews ?
      `<div class="product-rating">${getStarsImage(averageReview)} ${averageReview.toFixed(1)}</div>`
      : ''

    let lastSeenSectionLoggedIn = "";
    const customerState = $("#selected_distributor_location").length > 0 ? $("#selected_distributor_location").html() : null;

    let selectedReviewScores = ($("#selected_review_score").val() || "").split(",").map(parseFloat);
    selectedReviewScores.sort((a, b) => a - b);
    
    if (selectedReviewScores.length > 0 && selectedReviewScores[0]) {
      let score_from, score_to;
      score_to = selectedReviewScores[selectedReviewScores.length - 1];
      score_to = score_to < 5 ? score_to + 0.4 : score_to;
      score_from = selectedReviewScores[0] > 1 ? selectedReviewScores[0] - 0.9 : 0;

      let reviews = getLocalStorageItem("yotpo_reviews");
      if (reviews && reviews[item.shopify_id]) {
        const productReviewInfo = reviews[item.shopify_id];
        let isWithinRange = false;
        if (productReviewInfo.score >= score_from && productReviewInfo.score <= score_to) {
          isWithinRange = true;
        }
        if (!isWithinRange) {
          return;
        }
      } else {
        return;
      }
    }

    const regexList = [/(\binc\b$|\binc.\b$|\bltd\b$|\bllc\b$|\bdistributor?\b$|\bservices\b$|\bcorp\b$|\bgroup\b$|\bproducts\b$|\bsupplies\b$)/gi, /\bUSA\b$/g];

    if (customerState && item.last_seen_on_logged_in && item.last_seen_on_logged_in !== "") {
      let lastSeenOnLoggedIn = item.last_seen_on_logged_in;
      let items = [];
      if (Array.isArray(lastSeenOnLoggedIn)) {
        items = lastSeenOnLoggedIn;
      } else {
        items = [lastSeenOnLoggedIn];
      }

      items.forEach((item) => {
        item = item.split("_");
        const invoiceDate = new Date(item[0]);
        let distributorName = String(item[1] || '').trim();
        
        const applyDistributorNameRegex = () => {
          regexList.forEach(regex => {
            distributorName = distributorName.replace(regex, '').trim();
          });
        }
        // First Pass
        applyDistributorNameRegex();
        // Second Pass removes compound words like USA LLC
        applyDistributorNameRegex();
        
        const invoiceState = item[2];
        if (invoiceState === customerState) {
          const today = new Date();
          const diffTime = Math.abs(today - invoiceDate);
          let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
          // Expand filter to invoices within last 180 days, but display as under 90
          if (diffDays > 90 && diffDays <= 180) {
            diffDays -= 90;
          }
          if (diffDays <= 90) {
            lastSeenSectionLoggedIn += `<div class="last-seen-at-container">
              <label class="last-seen-at-label" for="last-seen-at">${distributorName}<span class="diff-days">${diffDays} days ago</span></label>
            </div>`;
          }
        }
      });
    }

    let lastSeenSectionLoggedOff = "";
    if (!customerState && item.last_seen_on_logged_off && item.last_seen_on_logged_off !== "") {
      let lastSeenOnLoggedOff = item.last_seen_on_logged_off;
      let items = [];
      if (Array.isArray(lastSeenOnLoggedOff)) {
        items = lastSeenOnLoggedOff;
      } else {
        items = [lastSeenOnLoggedOff];
      }
      items.forEach((item, index) => {
        if (index > 1) return; // Only show 2 items in search results for "Most recent invoices seen".
        item = item.split("_");
        const invoiceDate = new Date(item[0]);
        let distributorName = item[1];
        regexList.forEach(regex => {
          distributorName = distributorName.trim().replace(regex, '');
        });
        const today = new Date();
        const diffTime = Math.abs(today - invoiceDate);
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        // Expand filter to invoices within last 180 days, but display as under 90
        if (diffDays > 90 && diffDays <= 180) {
          diffDays -= 90;
        }
        if (diffDays <= 90) {
          lastSeenSectionLoggedOff += `<div class="last-seen-at-container">
            <label class="last-seen-at-label" for="last-seen-at">${distributorName}</label>
            <p class="diff-days">${diffDays} days ago</p>
          </div>`;
        }
      });
    }

    let itemUrl = item.URL;
    
    let onProductClick = '';
    let linkData = '';
    if(isProductFeatured) {
      itemUrl = item.search_url ? "#" : item.URL;
      onProductClick = isProductFeatured && item.search_url ? `onclick="event.preventDefault(); event.stopImmediatePropagation(); onExternalFeaturedProductClick('${$('#st-search-input').val()}', '${item.shopify_id}', '${encodeURIComponent(item.title).replace(/'/g, "\\'")}', '${encodeURIComponent(item.search_url ? item.search_url : item.URL)}');return false;"`: '';
      // Use data atributes to pass data to the trackLink
      linkData = `data-search-text='${$('#st-search-input').val()}' data-product-id='${item.shopify_id}' data-product-title='${encodeURIComponent(item.title).replace(/'/g, "\\'")}'`;
    }

    var itemHtml = `
        <div class="search-result ${isProductFeatured ? 'featured' : ''}">
          <div class="product-image">
            <a ${isProductFeatured ? 'class="track-click"': ''} href="${itemUrl}" ${linkData} ${onProductClick}>
              <img src="${item.image}" alt="${item.title}">
            </a>
          </div>
          <div class="product-meta">
            <a ${isProductFeatured ? 'class="track-click"': ''} href="${itemUrl}" ${linkData} ${onProductClick}><h3>${item.title}</h3></a>
            ${hasReviews ? reviewStars : ''}
            <div id="product-description-${item.id}" class="product-description">${hasReviews ? '' : item.description}</div>
            <div class="product-link">
              <a ${isProductFeatured ? 'class="track-click"': ''} href="${itemUrl}" ${linkData} ${onProductClick}>Read more</a>
            </div>
          </div>
          <div class="product-info">
            ${rebatesAndRewards}
            ${invoicesInfo ?
          `<div class="recent-invoices">
                Recent invoices in <br> 
                ${invoicesInfo}
              </div>
              <div class="view-all-suppliers"><a href="#">View all suppliers</a></div>`
          : ``}
          ${lastSeenSectionLoggedIn !== "" ? "<p class=\"mb-1 recent-invoices-title\">Recent invoices in <b>" + customerState + "</b>:</p>" + lastSeenSectionLoggedIn + `<div class="view-all-suppliers"><a href="${itemUrl}" ${linkData} ${onProductClick}>View all suppliers</a></div>` : ""}
          ${lastSeenSectionLoggedOff !== "" ? "<p class=\"mb-1 recent-invoices-title\">Most recent invoice seen:</p>" + lastSeenSectionLoggedOff : ""}
          </div>
          ${isProductFeatured ? `<script type="text/javascript">trackFeatureProductImpression("${$('#st-search-input').val()}", "${item.shopify_id}", "${item.title}");</script>` : ''}
        </div>
    `
    return itemHtml;
  };

  $("input[name=filter_category], input[name=filter_brand], input[name=filter_distributor], input[name=filter_has_review_image], input[name=filter_points], input[name=filter_rewards], input[name=filter_has_q_and_a]").on('change', filterChange)

  $("[name^='filter_average_review_']").on('change', function () {
    filterChange();
  });

  $(".clear_filters").on('click', clearFilters)

  $('.mobile_search_trigger').on('click', function () {
    $('.header__search-form').addClass('mobile-search-open');
    $('.mobile-search-overlay').removeClass('d-none');
  });

  $('.close_icon').on('click', function () {
    $('.header__search-form').removeClass('mobile-search-open');
    $('.mobile-search-overlay').addClass('d-none');
  });

  $('.mobile-search-overlay').on('click', function () {
    $('.close_icon').on('click');
  });

  // This function is triggered when a user clicks on a product in the automplete search results.
  // Swiftype documentation: https://github.com/swiftype/swiftype-autocomplete-jquery#changing-what-happens-when-an-item-is-selected-in-the-dropdown
  var defaultAutocompleteOnComplete = function(item) {
    const isProductFeatured = item._score === 1;
    if(isProductFeatured) {
      const searchText = $('#st-search-input').val();
      trackFeatureProductClick(searchText, item.shopify_id, item.title);
      if(item.search_url) { // If the item has a Search_URL, redirect to it in a new tab.
        window.open(item.URL, '_blank');
        return;
      }
    }
    window.location = item.URL ? item.URL : item.url;
  };

  var commonSettings = {
    engineKey: swiftypeKey,
    suggestionListType: 'div',
    resultListSelector: '.result',
    highlightFields: { 'page': { 'title': { 'size': 100, 'fallback': true } } },
  }

  var autocompleteSettings = {
    resultRenderFunction: customResultRenderFunction,
    fetchFields: { page: ['title', 'url', 'image', 'brand', 'shopify_id', 'search_url', 'URL'] },
    resultLimit: 4,
    onComplete: defaultAutocompleteOnComplete,
  }

  var searchSettings = {
    renderFunction: customSearchResultRenderFunction,
    resultContainingElement: '#st-results-container',
    fetchFields: { page: ['title', 'url', 'image', 'brand', 'description', 'URL', 'suppliers', 'suppliers_state', 'rebates', 'points', 'average_review', 'minor_category', 'shopify_id', 'last_seen_on_logged_in', 'last_seen_on_logged_off', 'search_url'] },
    filters: readFilters,
    perPage: 100,
    preRenderFunction: function (data) {
      var query = data.info.page.query;
      updateFilters(query)
      $('#st-search-input, #st-search-page-input').val(query);
      $('#searchtitle').html(`Results for "${query}"`);
    },
    postRenderFunction: function () {
      const featuredResults = $(".search-result.featured");
      if (featuredResults.length > 0) {
        const firstTwo = featuredResults.slice(0, 2);
        $(firstTwo).detach().appendTo(".search-section-results.featured");
        $(".search-section.featured").removeClass("d-none");
        $(".not-featured .featured").removeClass("featured");
      } else {
        $(".search-section.featured").addClass("d-none");
      }

      // After results render, bind the track click event to the featured products (applies only to non-external products)
      const linksToTrack = $('.track-click');
      linksToTrack.each(function(index, link){
    
        analytics.trackLink(link, 'Featured Product Clicked', {
          category: 'Search',
          label: decodeURIComponent($(link).data('product-title')),
          search_text: $(link).data('search-text'),
          product_id: $(link).data('product-id'),
          product_title: decodeURIComponent($(link).data('product-title'))
        });
      });
    },
    loadingFunction: function () {
      $(".search-section-results").html("");
      $("#st-search-input").html('<p class="st-loading-message">loading...</p>');
    }
  }

  $('#st-search-input').parents('form').on('submit', function (e) {
    e.preventDefault();
    goSearch();
  });

  $('#st-search-input').swiftype({ ...commonSettings, ...autocompleteSettings });
  $('#st-search-page-input').swiftypeSearch({ ...commonSettings, ...searchSettings });

  $('#st-search-input').on('focus', function () {
    makeSquare('.squared');
  });

});

